import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface LapsedSubscriptionAlertFilters {
  // "collected" is the legacy value; the API writes "resolved" from Phase 3.
  status?: "active" | "resolved" | "collected" | "all";
  page?: number;
  limit?: number;
}

export const useGetLapsedSubscriptionAlerts = (
  filters: LapsedSubscriptionAlertFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.LAPSED_SUBSCRIPTION_ALERTS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
